module.exports = __webpack_public_path__ + "img/logo-min.99831a8d.png";